const savoirI18n = {
  "fr": {
    "savoir": {
      "title": "En savoir plus",
      "intro": "Parce que la confiance et la sécurité sont essentielles, nous avons mis en place des processus clairs à chaque étape. Découvrez comment nous protégeons vos envois et comment nous assurons une transparence totale lors du rachat de vos pièces.",
      "cards": {
        "security": {
          "title": "Pour un envoi en toute sécurité",
          "body": "Protégez vos écrans avec du papier bulle ou un carton solide afin d’éviter toute casse pendant le transport. Chaque pièce bien emballée, c’est un paiement garanti sans mauvaise surprise.",
          "cta": "En savoir +"
        },
        "transparent": {
          "title": "Un rachat transparent",
          "body": "Dès réception, nous contrôlons vos pièces et vous envoyons un rapport clair. Le prix annoncé est respecté et le paiement déclenché immédiatement après validation.",
          "cta": "En savoir +"
        }
      },
      "collect": {
        "title": "Des collectes d’appareils pour les entreprises",
        "body": "123back organise aussi des collectes de téléphones, tablettes et ordinateurs portables cassés ou inutilisés au sein des entreprises. Une action RSE simple, suivie avec transparence et accompagnée d’un bilan concret sur les appareils récupérés, dépollués et recyclés.",
        "cta": "Découvrir Collect"
      }
    }
  },
  "en": {
    "savoir": {
      "title": "Learn more",
      "intro": "Because trust and safety are essential, we’ve set up clear processes at every step. Discover how we protect your shipments and ensure full transparency when buying back your parts.",
      "cards": {
        "security": {
          "title": "For safe shipping",
          "body": "Protect your screens with bubble wrap or sturdy cardboard to avoid any damage during transport. Properly packed items mean guaranteed payment with no surprises.",
          "cta": "Learn more"
        },
        "transparent": {
          "title": "Transparent buyback",
          "body": "Upon receipt, we inspect your parts and send you a clear report. The quoted price is honored and payment is triggered immediately after approval.",
          "cta": "Learn more"
        }
      },
      "collect": {
        "title": "Device collections for companies",
        "body": "123back also organises collections of broken or unused phones, tablets and laptops within companies. A simple CSR initiative, with transparent monitoring and a clear report on the devices collected, depolluted and recycled.",
        "cta": "Discover Collect"
      }
    }
  },
  "pl": {
    "savoir": {
      "title": "Dowiedz się więcej",
      "intro": "Ponieważ zaufanie i bezpieczeństwo są kluczowe, wdrożyliśmy jasne procesy na każdym etapie. Zobacz, jak chronimy Twoje przesyłki i zapewniamy pełną transparentność odkupu części.",
      "cards": {
        "security": {
          "title": "Bezpieczna wysyłka",
          "body": "Chroń ekrany folią bąbelkową lub solidnym kartonem, aby uniknąć uszkodzeń w transporcie. Dobrze zapakowana część to gwarancja płatności bez niespodzianek.",
          "cta": "Więcej informacji"
        },
        "transparent": {
          "title": "Transparentny odkup",
          "body": "Po otrzymaniu sprawdzamy części i wysyłamy jasny raport. Podana cena jest respektowana, a płatność uruchamiana natychmiast po akceptacji.",
          "cta": "Więcej informacji"
        }
      },
      "collect": {
        "title": "Zbiórki urządzeń dla firm",
        "body": "123back organizuje również w firmach zbiórki uszkodzonych lub nieużywanych telefonów, tabletów i laptopów. To prosta inicjatywa CSR z przejrzystym monitoringiem oraz konkretnym raportem dotyczącym zebranych, oczyszczonych i poddanych recyklingowi urządzeń.",
        "cta": "Odkryj Collect"
      }
    }
  },
  "es": {
    "savoir": {
      "title": "Más información",
      "intro": "Porque la confianza y la seguridad son esenciales, hemos establecido procesos claros en cada etapa. Descubre cómo protegemos tus envíos y cómo garantizamos una total transparencia en la recompra de tus piezas.",
      "cards": {
        "security": {
          "title": "Para un envío seguro",
          "body": "Protege tus pantallas con papel burbuja o una caja resistente para evitar daños durante el transporte. Cada pieza bien embalada garantiza un pago sin sorpresas.",
          "cta": "Saber más"
        },
        "transparent": {
          "title": "Una recompra transparente",
          "body": "Al recibir tu paquete, inspeccionamos tus piezas y te enviamos un informe claro. El precio anunciado se respeta y el pago se realiza inmediatamente tras la validación.",
          "cta": "Saber más"
        }
      },
      "collect": {
        "title": "Recogidas de dispositivos para empresas",
        "body": "123back también organiza recogidas de teléfonos, tabletas y ordenadores portátiles rotos o sin usar dentro de las empresas. Una iniciativa de RSC sencilla, con seguimiento transparente y un informe concreto sobre los dispositivos recogidos, descontaminados y reciclados.",
        "cta": "Descubrir Collect"
      }
    }
  },
  "it": {
    "savoir": {
      "title": "Scopri di più",
      "intro": "Poiché la fiducia e la sicurezza sono essenziali, abbiamo impostato processi chiari ad ogni passo. Scopri come proteggiamo le tue spedizioni e garantiamo piena trasparenza quando acquisti le tue parti.",
      "cards": {
        "security": {
          "title": "Per la spedizione sicura",
          "body": "Proteggi i tuoi schermi con l'involucro della bolla o il cartone robusto per evitare danni durante il trasporto. Articoli confezionati correttamente significa pagamento garantito senza sorprese.",
          "cta": "Scopri di più"
        },
        "transparent": {
          "title": "Ricambio trasparente",
          "body": "Al ricevimento, ispezioniamo le vostre parti e vi inviamo un rapporto chiaro. Il prezzo citato è onorato e il pagamento viene attivato immediatamente dopo l'approvazione.",
          "cta": "Scopri di più"
        }
      },
      "collect": {
        "title": "Raccolte di dispositivi per le aziende",
        "body": "123back organizza anche raccolte aziendali di telefoni, tablet e computer portatili rotti o inutilizzati. Un’iniziativa CSR semplice, monitorata con trasparenza e accompagnata da un rapporto concreto sui dispositivi raccolti, bonificati e riciclati.",
        "cta": "Scopri Collect"
      }
    }
  },
  "de": {
    "savoir": {
      "title": "Erfahren Sie mehr",
      "intro": "Da Vertrauen und Sicherheit unerlässlich sind, haben wir bei jedem Schritt klare Prozesse eingerichtet. Erfahren Sie, wie wir Ihre Sendungen schützen und beim Rückkauf Ihrer Teile volle Transparenz gewährleisten.",
      "cards": {
        "security": {
          "title": "Für eine sichere Schifffahrt",
          "body": "Schützen Sie Ihre Bildschirme mit Luftpolsterfolie oder robustem Karton, um Schäden beim Transport zu vermeiden. Richtig verpackte Artikel bedeuten eine garantierte Zahlung ohne Überraschungen.",
          "cta": "Erfahren Sie mehr"
        },
        "transparent": {
          "title": "Transparenter Rückkauf",
          "body": "Nach Erhalt prüfen wir Ihre Teile und senden Ihnen einen klaren Bericht. Der angegebene Preis wird eingehalten und die Zahlung wird sofort nach der Genehmigung ausgelöst.",
          "cta": "Erfahren Sie mehr"
        }
      },
      "collect": {
        "title": "Gerätesammlungen für Unternehmen",
        "body": "123back organisiert auch Sammlungen von defekten oder ungenutzten Smartphones, Tablets und Laptops in Unternehmen. Eine unkomplizierte CSR-Maßnahme mit transparenter Begleitung und einem konkreten Bericht über die gesammelten, schadstoffentfrachteten und recycelten Geräte.",
        "cta": "Collect entdecken"
      }
    }
  },
  "pt": {
    "savoir": {
      "title": "Saiba mais",
      "intro": "Porque confiança e segurança são essenciais, nós estabelecemos processos claros a cada passo. Descubra como protegemos seus envios e garanta total transparência ao comprar suas peças de volta.",
      "cards": {
        "security": {
          "title": "Para transporte seguro",
          "body": "Proteja suas ecrãs com plástico bolha ou papelão resistente para evitar qualquer dano durante o transporte. Itens devidamente embalados significam pagamento garantido sem surpresas.",
          "cta": "Saiba mais"
        },
        "transparent": {
          "title": "Compras transparentes",
          "body": "Após o recibo, inspecionamos as suas partes e enviamos-lhe um relatório claro. O preço cotado é honrado e o pagamento é disparado imediatamente após a aprovação.",
          "cta": "Saiba mais"
        }
      },
      "collect": {
        "title": "Recolhas de equipamentos para empresas",
        "body": "A 123back também organiza recolhas de telemóveis, tablets e computadores portáteis avariados ou sem utilização nas empresas. Uma iniciativa de responsabilidade social simples, acompanhada com transparência e com um relatório concreto sobre os equipamentos recolhidos, descontaminados e reciclados.",
        "cta": "Descobrir Collect"
      }
    }
  },
  "cs": {
    "savoir": {
      "title": "Přečtěte si více",
      "intro": "Protože důvěra a bezpečnost jsou nezbytné, zavedli jsme jasné procesy na každém kroku. Zjistěte, jak chráníme vaše zásilky a zajistěte plnou transparentnost při nákupu vašich dílů.",
      "cards": {
        "security": {
          "title": "Pro bezpečnou přepravu",
          "body": "Chraňte své obrazovky bublinkovou fólií nebo robustní lepenkou, aby se zabránilo poškození během přepravy. Správně zabalené položky znamenají zaručenou platbu bez překvapení.",
          "cta": "Přečtěte si více"
        },
        "transparent": {
          "title": "Transparentní zpětný odkup",
          "body": "Po obdržení, jsme zkontrolovat vaše části a poslat vám jasnou zprávu. Citovaná cena je oceněna a platba se spustí ihned po schválení.",
          "cta": "Přečtěte si více"
        }
      },
      "collect": {
        "title": "Sbírky zařízení pro firmy",
        "body": "123backtaké organizuje kolekce rozbitých nebo nepoužitých telefonů, tablet a notebooků v rámci firem. Jednoduchá iniciativa CSR s transparentním sledováním a jasnou zprávou o shromážděných, znečištěných a recyklovaných zařízeních.",
        "cta": "Objevte Collect"
      }
    }
  },
  "nl": {
    "savoir": {
      "title": "Meer informatie",
      "intro": "Omdat vertrouwen en veiligheid essentieel zijn, hebben we bij elke stap duidelijke processen opgezet. Ontdek hoe wij uw zendingen beschermen en zorg voor volledige transparantie bij het terugkopen van uw onderdelen.",
      "cards": {
        "security": {
          "title": "Voor een veilige verzending",
          "body": "Bescherm uw schermen met bubble wrap of stevig karton om schade tijdens transport te voorkomen. Goed verpakte items betekenen gegarandeerde betaling zonder verrassingen.",
          "cta": "Meer informatie"
        },
        "transparent": {
          "title": "Transparante terugbetaling",
          "body": "Na ontvangst, inspecteren we uw onderdelen en sturen u een duidelijk rapport. De geciteerde prijs wordt gerespecteerd en de betaling wordt onmiddellijk na goedkeuring geactiveerd.",
          "cta": "Meer informatie"
        }
      },
      "collect": {
        "title": "Apparaatverzamelingen voor bedrijven",
        "body": "123backorganiseert ook collecties van kapotte of ongebruikte telefoons, tablets en laptops binnen bedrijven. Een eenvoudig MVO-initiatief, met transparante monitoring en een duidelijk verslag over de verzamelde, ontvuilde en gerecycleerde apparaten.",
        "cta": "Discover Collect"
      }
    }
  }
};

export default savoirI18n;
